/* Mattress & Interiors Co. | custom section scripts */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.mi-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function tabs(root) {
    (root || document).querySelectorAll('[data-mi-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var btns = wrap.querySelectorAll('.mi-tabs__btn');
      var panels = wrap.querySelectorAll('.mi-tabs__panel');
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b, j) { b.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = i !== j; });
        });
      });
      wrap.querySelectorAll('.mi-tabs__mtitle').forEach(function (t) {
        t.addEventListener('click', function () {
          var p = t.closest('.mi-tabs__panel');
          p.classList.toggle('is-open');
          t.setAttribute('aria-expanded', p.classList.contains('is-open') ? 'true' : 'false');
        });
      });
    });
  }


  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  function sliders(root) {
    (root || document).querySelectorAll('[data-mi-slider]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      var track = wrap.querySelector('[data-mi-track]');
      if (!track) return;
      wrap.dataset.ready = '1';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'mi-slider__arrow mi-slider__arrow--prev'; prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = ARROW;
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'mi-slider__arrow mi-slider__arrow--next'; next.setAttribute('aria-label', 'Next'); next.innerHTML = ARROW;
      var dots = document.createElement('div'); dots.className = 'mi-dots';
      wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(dots);
      var stops = [];
      function build() {
        var max = track.scrollWidth - track.clientWidth;
        var on = max > 4;
        wrap.classList.toggle('is-slider', on);
        stops = [];
        if (!on) { dots.innerHTML = ''; return; }
        var base = track.getBoundingClientRect().left - track.scrollLeft;
        Array.prototype.forEach.call(track.children, function (el) {
          var x = Math.min(Math.max(el.getBoundingClientRect().left - base, 0), max);
          if (!stops.length || Math.abs(x - stops[stops.length - 1]) > 8) stops.push(x);
        });
        if (Math.abs(stops[stops.length - 1] - max) > 8) stops.push(max);
        dots.innerHTML = '';
        stops.forEach(function (x, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'mi-dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { track.scrollTo({ left: stops[i], behavior: 'smooth' }); });
          dots.appendChild(d);
        });
        sync();
      }
      function current() {
        var l = track.scrollLeft, best = 0;
        stops.forEach(function (x, i) { if (Math.abs(x - l) < Math.abs(stops[best] - l)) best = i; });
        return best;
      }
      function sync() {
        if (!stops.length) return;
        var c = current();
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === c); });
        prev.disabled = c === 0; next.disabled = c === stops.length - 1;
      }
      prev.addEventListener('click', function () { var c = current(); if (c > 0) track.scrollTo({ left: stops[c - 1], behavior: 'smooth' }); });
      next.addEventListener('click', function () { var c = current(); if (c < stops.length - 1) track.scrollTo({ left: stops[c + 1], behavior: 'smooth' }); });
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { build(); }).observe(track);
      else window.addEventListener('resize', build);
      build();
    });
  }

  function init(root) { reveal(root); tabs(root); sliders(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
